import {Component, OnInit} from '@angular/core';
import {App, AppInfo} from '@capacitor/app';
import {AuthService} from './services/core/auth.service';
import {DateTime} from 'luxon';
import {Router} from '@angular/router';
import {User} from './interfaces/core/user';
import {environment} from '../environments/environment';
import {SyncService} from './services/core/sync.service';
import {db} from './tables/db.service';
import {TimeoutHelper} from './helpers/timeout-helper';
import {ErrorMessagesService} from './services/core/error-messages.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit {

  protected user: User;
  protected appInfo: AppInfo = null;
  protected environment = environment;

  constructor(private router: Router,
              private errorMessagesService: ErrorMessagesService,
              private authService: AuthService,
              protected syncService: SyncService) {
  }

  /**
   *
   */
  public ngOnInit(): void {
    App.addListener('backButton', () => {
      // deactivate the back button
    });

    App.addListener('pause', async () => {
      console.log('App pause');
    });

    App.addListener('resume', async () => {
      console.log('App resume');
      db.close();
      try {
        await this.retryDbOpen(3, 1000);
      }
      catch (error) {
        await this.errorMessagesService.showCustomErrorMessage('Datenbank', 'Fehler beim öffnen der Datenbank');
      }

      this.checkAuthToken().finally();
    });

    App.getInfo().then((appInfo: AppInfo) => {
      this.appInfo = appInfo;
    }).catch(() => {
      console.info('App info not available');
    });

    this.checkAuthToken().finally();
  }

  /**
   * Versucht, die DB-Verbindung wieder aufzubauen.
   * @param maxRetries maximale Anzahl an Versuchen
   * @param delay Start-Delay in Millisekunden, das bei jedem Versuch (optional) erhöht werden kann
   */
  private async retryDbOpen(maxRetries: number, delay: number): Promise<void> {
    let attempt = 0;
    while (attempt < maxRetries) {
      try {
        await db.open();
        console.log('Database connection re-established.');
        return;
      } catch (error) {
        attempt++;
        console.error(`Error while opening db connection. Attempt ${attempt} of ${maxRetries}`, error);
        if (attempt < maxRetries) {
          await TimeoutHelper.sleep(delay)
          delay *= 2;
        } else {
          console.error('Max retries reached. DB connection could not be re-established.');
        }
      }
    }
  }

  /**
   *
   * @private
   */
  private async checkAuthToken(): Promise<void> {
    const authToken = AuthService.getAuthToken();
    if(authToken) {
      if(DateTime.fromISO(authToken.expires).diffNow().as('seconds') < 0) {
        await this.authService.unlockLogin();
        if (this.router.url !== '/login') {
          await this.router.navigate(['/login']);
        }
      }
    }
  }

}
